export default __webpack_public_path__ + "static/2-8afa26cdab8f9bea33d7b6fac5bb3f1e.jpeg";